import InviteCompleteForm from "./InviteCompleteForm";

export default InviteCompleteForm;
